import { useEffect, useState } from "react";
import {
    List,
    Datagrid,
    TextField,
    TopToolbar,
    SelectInput,
    Button,
    FunctionField,
    useDataProvider,
    useListContext,
    DateField
} from "react-admin";
import { useParams } from "react-router";
import BackButton from '../../Components/BackButton';

const ListActions = () => {
    const { setFilters, filterValues } = useListContext();  // 获取列表上下文
    const initialFilters = {};  // 初始过滤器值

    // 重置过滤器函数
    const handleResetFilters = () => {
        setFilters(initialFilters);
    };

    return (
        <TopToolbar>
            <Button
                label="重置搜索"
                onClick={handleResetFilters}
                disabled={Object.keys(filterValues).length === 0}  // 当没有过滤条件时禁用
            />
        </TopToolbar>
    );
};


export const otaUpgradeDetails = () => {
    const params = useParams(); // 获取URL参数
    const tbDeviceId = params.id; // 提取设备ID

    // 构建返回设备详情页的路径
    const backPath = `/otaUpgrade/`;


    let postFilters = [
        <SelectInput
            alwaysOn
            key="otaType"
            source="otaType"
            label="OTA类型"
            choices={[
                {
                    id: 'FIRMWARE',
                    name: '固件',
                },
                {
                    id: 'SOFTWARE',
                    name: '软件',
                }
            ]}
        />,
    ];

    return (
        <>
            <TopToolbar sx={{ justifyContent: 'start' }}>
                <BackButton to={backPath} />
            </TopToolbar>
            <List title="升级历史记录" filter={{ tbDeviceId: tbDeviceId }} filters={postFilters} actions={< ListActions />} empty={false} resource="otaUpgradeDetails" >
                <Datagrid bulkActionButtons={false}>
                    {/* 修正字段映射 */}
                    <TextField source="id" label="序号" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }}/>
                    <TextField source="currentVersion" label="原版本" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }}/>
                    <TextField source="otaType" label="OTA类型" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }}/>
                    <TextField source="sn" label="设备SN" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }}/>
                    <FunctionField
                        label="升级状态"
                        source="status"
                        render={record => {
                            let str = ''
                            switch (record.status) {
                                case 'DOWNLOADING':
                                    str = '下载更新包中'
                                    break;
                                case 'DOWNLOADED':
                                    str = '完成下载'
                                    break;
                                case 'VERIFIED':
                                    str = '已验证下载包'
                                    break;
                                case 'UPDATING':
                                    str = '启动更新中'
                                    break;
                                case 'UPDATED':
                                    str = '已成功更新'
                                    break;
                                case 'FAILED':
                                    str = '更新失败'
                                    break;
                            }
                            return str
                        }}
                        sortable={false}
                    />
                    <TextField source="targetVersion" label="目标版本" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }}/>
                    <TextField source="title" label="版本名称" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }}/>
                    <DateField source="createTime" label="升级时间" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }}/>
                    <DateField source="createTime" label="更新时间" sortable={false} sx={{
                    whiteSpace: 'nowrap',
                }}/>
                </Datagrid>
            </List >
        </>
    );
};